//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import PartnerFooter from '@/components/common/footer/PartnerFooter'
import Preloader from '@/components/common/Preloader'
import GdprCookieModal from '@/modules/gdpr/components/GdprCookieModal'
import EkbModal from '@/modules/ekbModal/components/EkbModal'
import BarnaulModal from '@/modules/barnaulModal/components/BarnaulModal'
import NovosibirskModal from '@/modules/novosibirskModal/components/NovosibirskModal'
import CityBillet from '~/components/modals/CityBillet'

export default {
  name: 'PartnerLayout',
  components: {
    PartnerFooter,
    GdprCookieModal,
    EkbModal,
    BarnaulModal,
    NovosibirskModal,
    CityBillet,
    Preloader,
  },
  computed: mapGetters({
    gdprSaved: 'gdpr/gdprSaved',
  }),
  methods: {
    isRussianFranchise() {
      return this.$getTextMainSetting('isRussianFranchise')
    },
  },
}
